import { useBreakpoints } from '@vueuse/core';
import { ref, type Ref } from 'vue';

export function useScreenSizeComposable() {
  const isLaptop: Ref<boolean> = ref(false);
  const isTablet: Ref<boolean> = ref(false);
  const isMobile: Ref<boolean> = ref(false);
  const mediaQuery = window.matchMedia('(max-width: 767px)');

  const breakpoints = useBreakpoints({
    'sm': 540,
    'md': 720,
    'lg': 960,
    'xl': 1140,
    '2xl': 1280,
  });

  function screenSizeCheck(): void {
    isLaptop.value = breakpoints.isSmallerOrEqual('lg');
    isTablet.value = breakpoints.isSmallerOrEqual('md');
    isMobile.value = breakpoints.isSmallerOrEqual('sm');
  }

  return {
    isLaptop,
    isTablet,
    isMobile,
    mediaQuery,
    screenSizeCheck,
  };
}
